import { DefaultTheme, DarkTheme } from '@msx/react-ui-component';
import { IAppTheme } from '@msx/platform-services';
import { appConfig } from '../../app/App.config';
import queryString from 'query-string';
import { getCustomTheme } from './theme';
import { toast } from 'react-toastify';

let navScrollBarWidth = 0;

export const getScrollBarWidth = () => {
  if (navScrollBarWidth !== 0) {
    return navScrollBarWidth;
  }
  // Get the browser scrollbar width because they're all different
  var scrollDiv = document.createElement('div');
  scrollDiv.setAttribute('style', 'width: 100px;height: 100px;overflow: scroll;position: absolute;top: -999px;');
  var contentDiv = document.createElement('p');
  contentDiv.setAttribute('style', 'width: 100px;height: 200px;');
  scrollDiv.appendChild(contentDiv);
  document.body.appendChild(scrollDiv);
  navScrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return navScrollBarWidth;
}


// export const getThemeByName = (name: string): IAppTheme => {
//   const theme = name === 'dark' ? DarkTheme : DefaultTheme;
//   return theme;
// }

export const getThemeByName = (name: string): IAppTheme => {
  const [customDefaultTheme, customDarkTheme] = getCustomTheme(DefaultTheme, DarkTheme)
  const theme = name === 'dark' ? customDarkTheme : customDefaultTheme;
  return theme;
}

export const initializeBot = () => {
  if (appConfig.botConfig.active) {
    const script = document.createElement("script");
    script.src = appConfig.botConfig.scriptUrl;
    document.head.appendChild(script);
  }
}

export const initializeOcv = () => {
  if (!appConfig.ocvFeedbackConfig.active)
    return;

  const Window = window as any;

  Window.OfficeBrowserFeedback = window.OfficeBrowserFeedback || {};
  Window.OfficeBrowserFeedback.initOptions = {
    appId: appConfig.ocvFeedbackConfig.appId, // Replace by your own app id
    stylesUrl: `${appConfig.ocvFeedbackConfig.sdkUrl}styles/officebrowserfeedback.css`, // Replace by where you have hosted the .css
    intlUrl: `${appConfig.ocvFeedbackConfig.sdkUrl}intl/`, // Replace by where you have hosted the intl files.
    environment: 0, // 0 - Prod, 1 - Int
    primaryColour: "#008272", // Replace by a colour which goes with your website.
    secondaryColour: "#004B50",// Replace by a colour which goes with your website.
    onError: function onError(err) { console.log("OfficeBrowserFeedback SDK encountered error: " + err); }, // (optional) Callback which gets executed when SDK errors
    bugForm: true, // (optional) false by DefaultTheme
    isShowThanks: true,
  };

  (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = `${appConfig.ocvFeedbackConfig.sdkUrl}scripts/officebrowserfeedback.js`;
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'officebrowserfeedback-jssdk'));

  Window.startMultiFeedback_AllOptional = function startMultiFeedback_AllOptional() {
    var launchOptions = {
      telemetryGroup: {
        sourceContext: appConfig.appName,
      },
      categories: {
        show: true,
        customCategories: ["Calc", "Portal", "Marketing Events"]
      },
      // one app id with multiple
      // direct link with filter
      // filter to specific 
    };
    handlePromise(Window.OfficeBrowserFeedback.multiFeedback(launchOptions));
  };

}

function handlePromise(promise) {
  promise
    .then(
      function onFulfilled() { console.log('handlePromise succeeded'); }
    )
    .catch(
      function onRejected(err) { console.log('handlePromise failed with error: ' + err); }
    );
}

export function parseQueryString(url: string): any {
  let params = [];
  let obj = queryString.parse(url);
  Object.keys(obj).forEach(function (key, idx) {
    params.push(
      {
        key: key,
        value: obj[key]
      });
  });
  return params;
}

export class Guid {
  private static s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  static newGuid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }
}

/**
 * True when the portal is running inside a Dynamics (`*.dynamics.com`) iframe.
 *
 * A cross-origin child frame cannot read `window.parent.location`, so we detect
 * the framing origin via the signals that survive the same-origin boundary:
 *   1. `ancestorOrigins` — the frame's ancestor origin list (Chromium/WebKit;
 *      this covers Edge/Chrome, which is what Dynamics users run). Most reliable.
 *   2. `document.referrer` — the framing document's URL on initial load; used as
 *      a fallback for browsers without `ancestorOrigins` (e.g. Firefox).
 *   3. `?source=iframe` — the explicit embed contract the Dynamics web resource
 *      already appends (see react-in-mda-embedding-design.md); last-resort
 *      backstop when the referrer is stripped by a Referrer-Policy.
 *
 * Single source of truth for embed-aware behavior (MSAL cache location in
 * AppShellProvider; hiding the left nav + full-bleed content in the shell).
 */
export const isEmbeddedInDynamics = (): boolean => {
  try {
    // Explicit override for local testing only: force embedded mode via
    // `?source=iframe`. Gated to non-production so it can never affect real users.
    if (
      process.env.NODE_ENV !== 'production' &&
      /[?&]source=iframe(&|=|$)/i.test(window.location.search)
    ) {
      return true;
    }
    if (window.parent === window) return false; // top-level, not framed
    const hostIsDynamics = (value: string): boolean => {
      try {
        return /(^|\.)dynamics\.com$/i.test(new URL(value).hostname);
      } catch {
        return false;
      }
    };
    const ancestors = window.location.ancestorOrigins;
    if (ancestors && ancestors.length > 0) {
      return Array.from(ancestors).some(hostIsDynamics);
    }
    if (document.referrer) return hostIsDynamics(document.referrer);
    return false;
  } catch {
    return false;
  }
};

export const getEstimateId = () => {
  const searchParams = new URLSearchParams(window?.location?.search);
  return searchParams.get("estimateId");
};

export const getOpportunityId = () => {
  const searchParams = new URLSearchParams(window?.location?.search);
  return searchParams.get("opportunityId") || searchParams.get("OpportunityId");
};

export const getOpportunityLink = (id = '') => {
  const opportunityId = id ? id : getOpportunityId();
  return `${process.env.REACT_APP_Capacity_API_OPPORTUNITY_ENDPOINT}?opportunityId=${opportunityId}&RegionId=14`;
};

export const processFileToDownload = (data: any, templateType: string) => {
  try {
    // Ensure data is binary (arraybuffer)
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Set file name dynamically or as per your requirement
    if(templateType === 'nonexempt'){
      link.setAttribute("download", `Supplier scope and Milestone template (Rate Based).xlsm`);
    }else{
      link.setAttribute("download", `Supplier scope and Milestone template (Rate Exempt).xlsm`);
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    return true;
  } catch (err) {
    toast.error("Error in processing file download");
    return false;
  }
};
